module.exports = __webpack_public_path__ + "static/media/use-case-4.3826a43d.jpg";